import React from 'react';

import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { formatTimeStamp } from '../../../app/common/ui/DateTools';
import Spacer from '../../../app/common/ui/Spacer';
import getStateColour from '../../../app/colours.js';
import ArchiveItemButton from '../_common/ArchiveItemButton';

const MemberQuoteCard = ({ quote }) => {

    return (
        <Paper style={{ padding: '1rem', marginBottom: '1rem' }}>

            <Grid container spacing={1}>
                <Grid item><Typography variant="button" color="textSecondary">QUOTE</Typography></Grid>
                <Grid item style={{ marginLeft: 'auto' }}><Chip label={quote?.status} size="small" style={{ backgroundColor: getStateColour(quote?.status), color: 'white' }} /></Grid>
            </Grid>
            <Typography variant="subtitle2">For {quote.digest?.organization}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Reference {quote.digest?.bookingReference}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Court Case Number {quote.digest?.courtCaseNumber}</Typography>
            <Spacer space='0.5rem' />
            <Typography variant="body2">{quote.digest?.message || quote.id}</Typography>
            <Typography variant="caption">Last updated {formatTimeStamp(quote.ts)}</Typography>
            <Spacer space='0.5rem' />
            <Grid container>
                <Grid item>
                    <Link href={`/casework/quote/${quote.id}`} color="primary">Edit / View</Link>
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <ArchiveItemButton doc={quote} docType="quote" />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default MemberQuoteCard;